import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RouteTrackerService {

  private lastUrl: string | null = null;

  // Pages that should never be remembered as a "return to" target —
  // redirecting a user back to /login or /logout after they log in
  // would be pointless or would create a loop.
  private readonly excludedPrefixes = ['/login', '/login-teacher', '/logout'];

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = event.urlAfterRedirects;
        const isExcluded = this.excludedPrefixes.some(prefix => url.startsWith(prefix));

        if (!isExcluded) {
          this.lastUrl = url;
        }
      });
  }

  getLastUrl(): string | null {
    return this.lastUrl;
  }
}